// import { useContext, useEffect, useState, useRef } from "react";
// import { FaSearch } from "react-icons/fa";
// import { Link, NavLink, useLocation } from "react-router-dom";
// import { SearchContext } from "../../contexts/searchContext/searchContext";
// import { useStickyNav } from "../../hooks/useStickyNav";
// import { RiMenuFoldFill } from "react-icons/ri";
// import classnames from "classnames";
// import { MdOutlineArrowDropDown } from "react-icons/md";
// import "./nav.scss";


// const Nav = () => {
//   const menu = useRef(null);
//   const { setOpenModal, openModal } = useContext(SearchContext);
//   const { sentinel, isSticky } = useStickyNav();
//   const [menuDrawer, setMenuDrawer] = useState(false);
//   const [openSubLink, setOpenSubLink] = useState(false);

//   const location = useLocation();
//   const closeOpenMenus = (e) => {
//     if (menu.current && openSubLink && !menu.current.contains(e.target)) {
//       setOpenSubLink(false);
//     }
//   };
//   document.addEventListener("mousedown", closeOpenMenus);
//   useEffect(() => {
//     setMenuDrawer(false);
//   }, [location.pathname]);

//   const isHomePage = location.pathname === "/";

//   return (
//     <>
//       <nav className={isSticky ? "nav sticky" : "nav"}>
//         <div className="nav--container">
//           <Link to={"/"} className="logo">
//             {isSticky ? (
//             //   <Avatar
//             //   alt="Logo"
//             //   src="/new-logo.png"
//             //   className="logo-img"
//             // />
//               <img src="/new-logo.png" alt="property logo" className="small-logo" />
//             ) : (
//               <img src="/new-logo.png" alt="property logo" className="logo-img" />
//               // <Avatar
//               //   alt="Logo"
//               //   src="/new-logo.png"
//               //   className="logo-img"
//               // />
//             )}
//           </Link>

//           {/* className={classnames("pagination-item", {
//               selected: pageNumber === currentPage,
//             })}
//             onClick={() => onPageChange(pageNumber)}
//           > */}
//           <ul
//             className={classnames("nav--links", {
//               active: menuDrawer,
//             })}
//           >
//             <li className="nav--links__link">
//               <NavLink
//                 to={"/"}
//                 className={({ isActive }) => (isActive ? "navActive" : "")}
//                 end
//               >
//                 Home
//               </NavLink>
//             </li>
//             <li className="nav--links__link">
//               <NavLink
//                 to={"/areas"}
//                 className={({ isActive }) => (isActive ? "navActive" : "")}
//                 end
//               >
//                 Area
//               </NavLink>
//             </li>

//             <li className="nav--links__link" ref={menu}>
//               <span onClick={() => setOpenSubLink(!openSubLink)}>
//                 properties{" "}
//                 <MdOutlineArrowDropDown
//                   className={openSubLink ? "arrowIcon rotate" : "arrowIcon"}
//                 />
//               </span>

//               <ul className={openSubLink ? "sub--links active" : "sub--links"}>
//                 <li className="sub--link">
//                   <NavLink
//                     to={"/listingform"}
//                     onClick={() => setOpenSubLink(false)}
//                     className={({ isActive }) =>
//                       isActive ? "subLinkActive" : ""
//                     }
//                     end
//                   >
//                     List Your Property
//                   </NavLink>
//                 </li>
//                 <li className="sub--link">
//                   <NavLink
//                     to={"/properties"}
//                     onClick={() => setOpenSubLink(false)}
//                     className={({ isActive }) =>
//                       isActive ? "subLinkActive" : ""
//                     }
//                     end
//                   >
//                     View All
//                   </NavLink>
//                 </li>
//                 <li className="sub--link">
//                   <NavLink
//                     to={"/properties-for-rent"}
//                     onClick={() => setOpenSubLink(false)}
//                   >
//                     For Rent
//                   </NavLink>
//                 </li>
//                 <li className="sub--link">
//                   <NavLink
//                     to="/properties-for-sale"
//                     onClick={() => setOpenSubLink(false)}
//                   >
//                     For Sale
//                   </NavLink>
//                 </li>
//               </ul>
//             </li>
//             {/* <li className="nav--links__link">
//               <NavLink
//                 to={"/properties-for-rent"}
//                 className={({ isActive }) => (isActive ? "navActive" : "")}
//                 end
//               >
//                 For Rent
//               </NavLink>
//             </li> */}
//             <li className="nav--links__link">
//               <NavLink
//                 to={"/developers"}
//                 className={({ isActive }) => (isActive ? "navActive" : "")}
//                 end
//               >
//                 Developers
//               </NavLink>
//             </li>
//             <li className="nav--links__link">
//               <NavLink
//                 to={"/contact"}
//                 className={({ isActive }) => (isActive ? "navActive" : "")}
//                 end
//               >
//                 Contact Us
//               </NavLink>
//             </li>
//             <li
//               className="nav--links__link"
//               onClick={() => setOpenModal(!openModal)}
//             >
//               <FaSearch className="searchIcon" />
//             </li>
//           </ul>
//           <div
//             className="searchIconOuter"
//             onClick={() => setOpenModal(!openModal)}
//           >
//             <FaSearch />
//           </div>

//           <RiMenuFoldFill
//             className={classnames("menu-icon", {
//               active: menuDrawer,
//             })}
//             onClick={() => setMenuDrawer(!menuDrawer)}
//           />
//         </div>
//       </nav>
//       {sentinel}
//     </>
//   );
// };

// export default Nav;









// import { useContext, useEffect, useState, useRef } from "react";
// import { FaSearch } from "react-icons/fa";
// import { Link, NavLink, useLocation } from "react-router-dom";
// import { SearchContext } from "../../contexts/searchContext/searchContext";
// import { useStickyNav } from "../../hooks/useStickyNav";
// import { RiMenuFoldFill } from "react-icons/ri";
// import classnames from "classnames";
// import { MdOutlineArrowDropDown } from "react-icons/md";
// import "./nav.scss";

// const Nav = () => {
//   const menu = useRef(null);
//   const { setOpenModal, openModal } = useContext(SearchContext);
//   const { sentinel, isSticky } = useStickyNav();
//   const [menuDrawer, setMenuDrawer] = useState(false);
//   const [openSubLink, setOpenSubLink] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [showStickyNav, setShowStickyNav] = useState(false); // Controls when sticky nav should be shown

//   const location = useLocation();
//   const isHomePage = location.pathname === "/"; // Check if it's the home page

//   const closeOpenMenus = (e) => {
//     if (menu.current && openSubLink && !menu.current.contains(e.target)) {
//       setOpenSubLink(false);
//     }
//   };

//   document.addEventListener("mousedown", closeOpenMenus);

//   useEffect(() => {
//     setMenuDrawer(false);
//   }, [location.pathname]);

  // useEffect(() => {
  //   if (isHomePage) {
  //     // For the home page, both normal and sticky nav should exist
  //     const handleScrollHomePage = () => {
  //       if (window.scrollY > 50) {
  //         setShowStickyNav(true); // Show sticky nav when scrolling
  //       } else {
  //         setShowStickyNav(false); // Hide sticky nav when at top
  //       }
  //     };

  //     // Attach scroll event listener for home page
  //     window.addEventListener("scroll", handleScrollHomePage);

  //     // Cleanup the event listener
  //     return () => {
  //       window.removeEventListener("scroll", handleScrollHomePage);
  //     };
  //   } else {
  //     // For other pages, only sticky nav should appear when scrolling
  //     const handleScrollOtherPages = () => {
  //       const isAtTop = window.screenY === 0;
  //       if (isAtTop) {
  //         // User is at the top of the page
  //         setIsScrolled(false);
  //         setShowStickyNav(false);  // Hide sticky nav when at the top
  //       } else if (window.scrollY > 50) {
  //         // User has scrolled down more than 50px
  //         setIsScrolled(true);
  //         setShowStickyNav(true);  // Show sticky nav when scrolling
  //       } else {
  //         // Scroll position is between 0 and 50px
  //         setIsScrolled(false);
  //         setShowStickyNav(true);  // Show sticky nav when between 0 and 50px
  //       }
  //       // if (window.scrollY > 50) {
  //       //   setIsScrolled(true);
  //       //   console.log("hereeeeeeeee", isScrolled)
  //       //   setShowStickyNav(true); // Show sticky nav when scrolling
  //       // } else {
  //       //   setShowStickyNav(false); // Hide sticky nav when at top
  //       // }
  //     };

  //     // Attach scroll event listener for other pages
  //     window.addEventListener("scroll", handleScrollOtherPages);

  //     // Cleanup the event listener
  //     return () => {
  //       window.removeEventListener("scroll", handleScrollOtherPages);
  //     };
  //   }
  // }, [isHomePage]);

//   return (
//     <>
//       {/* Show normal nav on home page, but sticky nav for both home and other pages when scrolling */}
//       {/* <nav style={{display: isHomePage ? 'block' : isScrolled ? 'block' : 'none'}} className={classnames("nav", {
//         sticky: (isHomePage && showStickyNav && isSticky) || (!isHomePage && showStickyNav && isSticky) // Sticky for home page when scrolled or always sticky for other pages
//       })}> */}
      //  <nav style={{display: isHomePage ? 'block' : isScrolled ? 'block' : 'none'}} className={isSticky ? "nav sticky" : "nav"}>
      //   <div className="nav--container">
//           <Link to={"/"} className="logo">
//             <img src="/new-logo.png" alt="property logo" className="logo-img" />
//           </Link>

//           <ul className={classnames("nav--links", { active: menuDrawer })}>
//             <li className="nav--links__link">
//               <NavLink to={"/"} className={({ isActive }) => (isActive ? "navActive" : "")} end>
//                 Home
//               </NavLink>
//             </li>
//             <li className="nav--links__link">
//               <NavLink to={"/areas"} className={({ isActive }) => (isActive ? "navActive" : "")} end>
//                 Area
//               </NavLink>
//             </li>
//             <li className="nav--links__link" ref={menu}>
//               <span onClick={() => setOpenSubLink(!openSubLink)}>
//                 Properties{" "}
//                 <MdOutlineArrowDropDown className={openSubLink ? "arrowIcon rotate" : "arrowIcon"} />
//               </span>

//               <ul className={openSubLink ? "sub--links active" : "sub--links"}>
//                 <li className="sub--link">
//                   <NavLink to={"/listingform"} onClick={() => setOpenSubLink(false)} className={({ isActive }) => (isActive ? "subLinkActive" : "")} end>
//                     List Your Property
//                   </NavLink>
//                 </li>
//                 <li className="sub--link">
//                   <NavLink to={"/properties"} onClick={() => setOpenSubLink(false)} className={({ isActive }) => (isActive ? "subLinkActive" : "")} end>
//                     View All
//                   </NavLink>
//                 </li>
//                 <li className="sub--link">
//                   <NavLink to={"/properties-for-rent"} onClick={() => setOpenSubLink(false)}>
//                     For Rent
//                   </NavLink>
//                 </li>
//                 <li className="sub--link">
//                   <NavLink to="/properties-for-sale" onClick={() => setOpenSubLink(false)}>
//                     For Sale
//                   </NavLink>
//                 </li>
//               </ul>
//             </li>

//             <li className="nav--links__link">
//               <NavLink to={"/developers"} className={({ isActive }) => (isActive ? "navActive" : "")} end>
//                 Developers
//               </NavLink>
//             </li>
//             <li className="nav--links__link">
//               <NavLink to={"/contact"} className={({ isActive }) => (isActive ? "navActive" : "")} end>
//                 Contact Us
//               </NavLink>
//             </li>

//             <li className="nav--links__link" onClick={() => setOpenModal(!openModal)}>
//               <FaSearch className="searchIcon" />
//             </li>
//           </ul>

//           <div className="searchIconOuter" onClick={() => setOpenModal(!openModal)}>
//             <FaSearch />
//           </div>

//           <RiMenuFoldFill
//             className={classnames("menu-icon", { active: menuDrawer })}
//             onClick={() => setMenuDrawer(!menuDrawer)}
//           />
//         </div>
//       </nav>

//       {sentinel}
//     </>
//   );
// };

// export default Nav;








import { useContext, useEffect, useState, useRef } from "react";
import { FaSearch } from "react-icons/fa";
import { Link, NavLink, useLocation } from "react-router-dom";
import { SearchContext } from "../../contexts/searchContext/searchContext";
import { useStickyNav } from "../../hooks/useStickyNav";
import { RiMenuFoldFill } from "react-icons/ri";
import classnames from "classnames";
import { MdOutlineArrowDropDown } from "react-icons/md";
import "./nav.scss";


const Nav = () => {
  const menu = useRef(null);
  const { setOpenModal, openModal } = useContext(SearchContext);
  const { sentinel, isSticky } = useStickyNav();
  const [menuDrawer, setMenuDrawer] = useState(false);
  const [openSubLink, setOpenSubLink] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const location = useLocation();
  const closeOpenMenus = (e) => {
    if (menu.current && openSubLink && !menu.current.contains(e.target)) {
      setOpenSubLink(false);
    }
  };
  document.addEventListener("mousedown", closeOpenMenus);
  useEffect(() => {
    setMenuDrawer(false);
  }, [location.pathname]);

  const isHomePage = location.pathname === "/";

  useEffect(() => {
    if (isHomePage) {
     
      const handleScrollHomePage = () => {
      };

   
      window.addEventListener("scroll", handleScrollHomePage);

   
      return () => {
        window.removeEventListener("scroll", handleScrollHomePage);
      };
    } else {
    
      const handleScrollOtherPages = () => {
        const isAtTop = window.screenY === 0;
        if (isAtTop) {
         
          setIsScrolled(false);
        
        } else if (window.scrollY > 50) {
        
          setIsScrolled(true);
          console.log("HELLLLOOOOOOOOOOO");
          console.log(isScrolled);
         
        } else {
          // Scroll position is between 0 and 50px
          setIsScrolled(false);
        
        }
       
      };

      // Attach scroll event listener for other pages
      window.addEventListener("scroll", handleScrollOtherPages);

      // Cleanup the event listener
      return () => {
        window.removeEventListener("scroll", handleScrollOtherPages);
      };
    }
  }, [isHomePage]);

  return (
    <>
       <nav style={{display: isHomePage ? 'block' : isSticky ? 'block' : 'none'}} className={isSticky ? "nav sticky" : "nav"}>
        <div className="nav--container">
          <Link to={"/"} className="logo">
            {isSticky ? (
            //   <Avatar
            //   alt="Logo"
            //   src="/new-logo.png"
            //   className="logo-img"
            // />
              <img src="/new-logo.png" alt="property logo" className="small-logo" />
            ) : (
              <img src="/new-logo.png" alt="property logo" className="logo-img" />
              // <Avatar
              //   alt="Logo"
              //   src="/new-logo.png"
              //   className="logo-img"
              // />
            )}
          </Link>

          {/* className={classnames("pagination-item", {
              selected: pageNumber === currentPage,
            })}
            onClick={() => onPageChange(pageNumber)}
          > */}
          <ul
            className={classnames("nav--links", {
              active: menuDrawer,
            })}
          >
            <li className="nav--links__link">
              <NavLink
                to={"/"}
                className={({ isActive }) => (isActive ? "navActive" : "")}
                end
              >
                Home
              </NavLink>
            </li>
            <li className="nav--links__link">
              <NavLink
                to={"/areas"}
                className={({ isActive }) => (isActive ? "navActive" : "")}
                end
              >
                Area
              </NavLink>
            </li>

            <li className="nav--links__link" ref={menu}>
              <span onClick={() => setOpenSubLink(!openSubLink)}>
                properties{" "}
                <MdOutlineArrowDropDown
                  className={openSubLink ? "arrowIcon rotate" : "arrowIcon"}
                />
              </span>

              <ul className={openSubLink ? "sub--links active" : "sub--links"}>
                <li className="sub--link">
                  <NavLink
                    to={"/listingform"}
                    onClick={() => setOpenSubLink(false)}
                    className={({ isActive }) =>
                      isActive ? "subLinkActive" : ""
                    }
                    end
                  >
                    List Your Property
                  </NavLink>
                </li>
                <li className="sub--link">
                  <NavLink
                    to={"/properties"}
                    onClick={() => setOpenSubLink(false)}
                    className={({ isActive }) =>
                      isActive ? "subLinkActive" : ""
                    }
                    end
                  >
                    View All
                  </NavLink>
                </li>
                <li className="sub--link">
                  <NavLink
                    to={"/properties-for-rent"}
                    onClick={() => setOpenSubLink(false)}
                  >
                    For Rent
                  </NavLink>
                </li>
                <li className="sub--link">
                  <NavLink
                    to="/properties-for-sale"
                    onClick={() => setOpenSubLink(false)}
                  >
                    For Sale
                  </NavLink>
                </li>
              </ul>
            </li>
            {/* <li className="nav--links__link">
              <NavLink
                to={"/properties-for-rent"}
                className={({ isActive }) => (isActive ? "navActive" : "")}
                end
              >
                For Rent
              </NavLink>
            </li> */}
            <li className="nav--links__link">
              <NavLink
                to={"/developers"}
                className={({ isActive }) => (isActive ? "navActive" : "")}
                end
              >
                Developers
              </NavLink>
            </li>
            <li className="nav--links__link">
              <NavLink
                to={"/contact"}
                className={({ isActive }) => (isActive ? "navActive" : "")}
                end
              >
                Contact Us
              </NavLink>
            </li>
            <li
              className="nav--links__link"
              onClick={() => setOpenModal(!openModal)}
            >
              <FaSearch className="searchIcon" />
            </li>
          </ul>
          <div
            className="searchIconOuter"
            onClick={() => setOpenModal(!openModal)}
          >
            <FaSearch />
          </div>

          <RiMenuFoldFill
            className={classnames("menu-icon", {
              active: menuDrawer,
            })}
            onClick={() => setMenuDrawer(!menuDrawer)}
          />
        </div>
      </nav>
      {sentinel}
    </>
  );
};

export default Nav;